import * as React from "react";
import {
  List, Datagrid, NumberField, FunctionField,
} from "react-admin";
import { Avatar, Box } from "@mui/material";

// Classement des pros — GET /ranking renvoie { entries, totalElements... }
// extraction faite via transformList dans resourceMap.
// RankingEntryDTO : id, firstName, lastName, photoUrl, points, rank (pas de métier).
export default {
  list: () => (
    <List perPage={50} pagination={false} title="Classement des professionnels">
      <Datagrid bulkActionButtons={false} rowClick={false}>
        <NumberField locales="fr-FR" source="rank" label="Rang" />
        <FunctionField label="Pro" render={(r) => (
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <Avatar src={r?.photoUrl} sx={{ width: 32, height: 32, bgcolor: "primary.main", fontSize: 14 }}>
              {((r?.firstName || "")[0] || "") + ((r?.lastName || "")[0] || "")}
            </Avatar>
            <Box>
              <Box sx={{ fontWeight: 600 }}>{r?.firstName} {r?.lastName}</Box>
              {r?.id && (
                <Box component="a" href={`#/professionals/${r.id}/show`} sx={{ color: "primary.main", fontSize: 12, fontWeight: 600, textDecoration: "none" }}>
                  Voir la fiche →
                </Box>
              )}
            </Box>
          </Box>
        )} />
        <NumberField locales="fr-FR" source="points" label="Points" />
      </Datagrid>
    </List>
  ),
};
